import React, {Component} from "react";
import "./Section.css";

import Header from "Header/Header";

export default class Section extends Component
{
	render()
	{
		return (
			<div className="section">
				{this.props.title && <Header title={this.props.title} />}

				{this.props.children}
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/Home/About/Section/Section.js